/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import { useHydration } from '@/hooks/use-hydration'
import dynamic from 'next/dynamic'
import Link from 'next/link'

const ArticlePMACarousel = dynamic(() =>
  import('@/components/molecules/carousel/article-pma-carousel').then((mod) => mod.ArticlePMACarousel)
)
import Container from '@/components/templates/container/container'

interface PMAArticleProps {
  title?: string
  language?: 'id' | 'en'
  data: PMA
}

export const PMAArticle = ({ title = 'Artikel Terbaru', language = 'id', data }: PMAArticleProps) => {
  const isHydrated = useHydration()

  if (!isHydrated || !data.items.length) {
    return null
  }

  return (
    <section className="bg-white py-9 lg:py-16">
      <Container className="space-y-6 lg:space-y-12">
        <header className="flex items-center justify-between gap-4 text-primary-blue">
          <h2 className="text-2xl font-extrabold lg:text-4xl">{title}</h2>
          <Link href="/artikel" className="text-sm font-medium hover:underline">
            {language === 'id' ? 'Lihat Semua Artikel' : 'See All Articles'}
          </Link>
        </header>

        <ArticlePMACarousel data={data} />
      </Container>
    </section>
  )
}
